import * as React from "react";
import { Biller } from "./billerCategoryTypes";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

type Props = {
  billers: Array<Biller>;
};

type State = {};

export default class AssociatedBillersContainer extends React.Component<
  Props,
  State
> {
  state = {};
  static defaultProps: Props = {
    billers: []
  };

  render() {
    return (
      <List component="nav">
        {this.props.billers.map((bill, index) => {
          return (
            <div key={index}>
              <BackOfficeLink
                backofficeUrl={`/snapscan/ops/biller_categories/billers/${bill.id}`}
              >
                <ListItem button>
                  <ListItemIcon>
                    <div className="small-icon">
                      <img
                        className="match-parent"
                        alt="No icon"
                        src={bill.logo}
                      />
                    </div>
                  </ListItemIcon>
                  <ListItemText inset primary={bill.name} />
                </ListItem>
              </BackOfficeLink>
            </div>
          );
        })}
      </List>
    );
  }
}
